import React from "react"

export default () => (
  <footer>
    <small className="bg-gray-900 text-gray-400 block text-center py-1">
      Copyright (C) 2020 merclimb All Rights Reserved.
    </small>
  </footer>
)
